var map = {
	"./decidim/avatar-multiuser.png": 62903,
	"./decidim/brands/facebook.svg": 33319,
	"./decidim/brands/google.svg": 78702,
	"./decidim/brands/twitter-x.svg": 1447,
	"./decidim/cc-badge.png": 53501,
	"./decidim/decidim-logo.svg": 28325,
	"./decidim/default-avatar.svg": 5989,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 2760,
	"./decidim/icons.svg": 21748,
	"./decidim/pattern.png": 41895,
	"./decidim/placeholder-card-g.svg": 45692,
	"./decidim/placeholder-card-l.svg": 47303,
	"./decidim/placeholder.jpg": 36222,
	"./decidim/remixicon.symbol.svg": 89620,
	"./decidim/vendor/social-share-button/douban.svg": 79143,
	"./decidim/vendor/social-share-button/email.svg": 75056,
	"./decidim/vendor/social-share-button/facebook.svg": 844,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 72072,
	"./decidim/vendor/social-share-button/hacker_news.svg": 81156,
	"./decidim/vendor/social-share-button/linkedin.svg": 97782,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 26383,
	"./decidim/vendor/social-share-button/pinterest.svg": 62366,
	"./decidim/vendor/social-share-button/reddit.svg": 40916,
	"./decidim/vendor/social-share-button/telegram.svg": 98265,
	"./decidim/vendor/social-share-button/tumblr.svg": 36534,
	"./decidim/vendor/social-share-button/twitter.svg": 13,
	"./decidim/vendor/social-share-button/vkontakte.svg": 50351,
	"./decidim/vendor/social-share-button/wechat.svg": 69242,
	"./decidim/vendor/social-share-button/whatsapp.svg": 50106,
	"./decidim/vendor/social-share-button/x.svg": 69744,
	"./decidim/vendor/social-share-button/xing.svg": 83224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;